<template>
  <b-card no-body class="shadow flex-container grid-stack-item-content flow-window">
    <div slot="header">
      <window-header cmp-title="Scorecard" widget-name="scorecard">
        <template slot="options">
          <!--<b-button :disabled="lo/ading" :pressed.sync="showPrefs" size="sm" variant="dark" type="dark" class="headerSmallButton"><icon name="cogs" scale=".7"></icon></b-button>-->

        </template>
      </window-header>
    </div>

    <div :style="{'flex': 2, 'overflow': 'hidden'}" class="position-relative pl-4 pr-4">
      <div class="row h-100">
        <div :style="{'width': '12rem', 'overflow': 'auto'}" class="h-100 border-right pr-1">
          <b-form-group label="Field:" label-for="scorecard-gas-dest">
            <b-form-select @input="onChangeDest" :options="gasDests" id="scorecard-gas-dest" v-model="selectedDest"
                           placeholder="Please, select option"></b-form-select>
          </b-form-group>

          <b-form-group label="Parameters:">
            <b-form-select multiple :select-size="5" v-model="selectedVar" :options="vars" @input="onChangeVar">
            </b-form-select>
          </b-form-group>

        </div>
        <div ref="renderArea" class=" h-100" :style="{'flex': 2, 'overflow': 'hidden', 'position': 'relative'}">
          <!--<svg ref="svg" class="h-100 w-100"></svg>-->
        </div>
      </div>
      <loading-overlay :show="loading"></loading-overlay>
    </div>
  </b-card>
</template>

<script>
  import LoadingOverlay from './LoadingOverlay'
  import WindowHeader from './common/WindowHeader'
  import moment from 'moment'

  import { scaleLinear, scaleTime, scaleOrdinal, schemeCategory20 } from 'd3-scale'
  import { extent } from 'd3-array'
  import { timeMonth, timeYear, timeDay } from 'd3-time'
  import { axisBottom, axisLeft } from 'd3-axis'
  import { select } from 'd3-selection'
  import { line as d3Line } from 'd3-shape'

  export default {
    name: 'Scorecard',
    components: {WindowHeader, LoadingOverlay},
    data () {
      return {
        loading: false,
        showPrefs: false,
        selectedDest: null,
        gasDests: [

        ],
        vars: [],
        selectedVar: [],
        data: null
      }
    },
    mounted () {
      this.loadGasDests()
      // this.loadData()
    },
    computed: {
      resized () {
        return this.$store.getters['map/widgetResizeMap']['scorecard']
      }
    },
    watch: {
      resized (val) {
        this.renderCharts()
      }
    },
    methods: {
      computeChartSize (countParams) {
        let bbox = this.$refs.renderArea.getBoundingClientRect()
        let width = bbox.width/Math.min(3, countParams)
        let height = bbox.height/Math.ceil(countParams/3)
        return [width, height]
      },
      computeChartPosition (size, num) {

        let top = Math.floor(num/3) * size[1]
        let left = (num % 3) * size[0]

        return {
          "width": size[0],
          "height": size[1],
          "left": left,
          "top": top,
        }
      },
      loadGasDests (clb) {
        this.$http.get('/api/projects/list-gas-dests', {
         params: {
           workpack_id: this.$store.getters['project/currentProject'].workpack.id
         }
        }).then(res => {
          res.body.forEach(d => {
            this.gasDests.push(d.gas_dest)
          })
          this.gasDests.length &&  (this.selectedDest = this.gasDests[0])
          clb && clb.call(this, res)
        }, e => {
          this.$notify({
            title: 'ERROR',
            text: 'Could not list gas dests',
            type: 'error'
          })
        })
      },
      onChangeVar () {
        console.log(this.selectedVar)
        this.renderCharts()
      },
      onChangeDest () {
        console.log(this.selectedDest)
        this.loadData()
      },
      renderCharts () {
        let renderArea = this.$refs.renderArea;
        let vars = this.selectedVar;
        if (vars.length > 9) {
          vars = [...vars].slice(-9)
          this.$notify({
            title: 'Parameter limit',
            text: 'Only 9 parameters rendered',
            type: 'info'
          })
        }
        let size = this.computeChartSize(vars.length)

        while (renderArea.firstChild) {
          renderArea.removeChild(renderArea.firstChild);
        }

        vars.forEach((v, i) => {
          let pos = this.computeChartPosition(size, i)
          let svgDom = document.createElementNS('http://www.w3.org/2000/svg', 'svg')
          svgDom.style.cssText = `position:absolute;top:${pos['top']}px;left:${pos['left']}px;width:${pos['width']}px;height:${pos['height']}px`
          renderArea.appendChild(svgDom)

          this.renderChart(svgDom, v)
        })
      },
      renderChart (svgDom, variable) {
        console.log('rendering chart')

        let svg = select(svgDom)
        svg.selectAll('*').remove()
        let bbox = svgDom.getBoundingClientRect()
        let paddingLeft = 90
        let paddingRight = 15
        let paddingBottom = 50
        let paddingTop = 15
        let width = bbox.width
        let height = bbox.height

        let fm = d => {
          return {
            'val': parseFloat(d[variable]),
            'ts': new Date(d['ts'])
          }
        }

        let b = this.data.map(fm)
        let yExtent = extent(b.map(d => d['val']))
        let xExtent = extent(b.map(d => d['ts']))

        if (yExtent[0] === yExtent[1]) {
          yExtent[0] = yExtent[0]/2
          yExtent[1] = yExtent[1] + yExtent[1]/2
        }
        let niceTime

        let df = moment.duration(moment(xExtent[0]).diff(moment(xExtent[1])))
        let days = df.asHours() * 24

        switch (true) {
          case days <= 31:
            niceTime = timeDay
            break;
          case ddays > 31 && days <= 365:
            niceTime = timeMonth
            break
          default:
            niceTime = timeYear
        }

        let scaleX = scaleTime().domain(xExtent).nice(niceTime).range([paddingLeft, width - paddingRight])
        let scaleY = scaleLinear().domain(yExtent).range([height - paddingBottom, paddingTop])

        let line = d3Line()
          .x(function (d, i) {return scaleX(d['ts']) })
          .y(function (d) { return scaleY(d['val']) })


        svg
          .append('path')
          .datum(b)
          .attr('fill', 'none')
          .attr('stroke', 'red')
          .attr('d', line)


        svg.append('g')
          .attr('class', 'xaxis')
          .attr('transform', 'translate(0,' + (height - paddingBottom) + ')')
          .call(axisBottom().scale(scaleX).ticks(niceTime))

        svg.selectAll('.xaxis text')  // select all the text elements for the xaxis
          .attr('transform', function (d) {
            return 'translate(' + this.getBBox().height * -2 + ',' + this.getBBox().height + ')rotate(-45)'
          })


        svg.append('g')
          .attr('class', 'yaxis')
          .attr('transform', 'translate(' + paddingLeft + ', 0)')
          .call(axisLeft().scale(scaleY))

        svg.append('g')
          .attr('transform', 'translate(' + (width/2) + ', 20)')
          .append('text')
          .attr('class', 'chart-title-text')
          .text(variable)

      },
      loadData () {
        this.$http.get('/api/projects/load-score-data',
          {
            params: {
              workpack_id: this.$store.getters['project/currentProject'].workpack.id,
              gas_dest: this.selectedDest
            }
          }
        ).then(res => {
          this.data = res.body

          if (this.data.length && !this.vars.length) {
            Object.keys(this.data[0]).filter(k => ['ts', 'id', 'workpack_id', 'gas_dest'].indexOf(k) === -1).forEach(k => {
              this.vars.push({
                text: k,
                value: k,

              })
            })
            this.selectedVar.push(this.vars[0].value)
          } else {
            this.renderCharts()
          }

          },
          e => {
            this.$notify({
              title: 'ERROR',
              text: 'Could not load data',
              type: 'error'
            })
          })
      }
    }

  }
</script>

<style lang="scss">
  .chart-title-text {
    fill: black;
    font-size: 16px;
    font-family: sans-serif;
  }
</style>



// WEBPACK FOOTER //
// src/components/Scorecard.vue